import { hasActiveZangiaPlus } from '@/features/jobs/lib/hasActiveZangiaPlus';
import { UserDTO } from '@/shared/user/user.dto';
import { ZangiaPlusMemberBadge } from './ZangiaPlusMemberBadge';

export function ZangiaPlusMemberBadgeIfActive({
  user,
  className,
}: {
  user?: UserDTO | null;
  className?: string;
}) {
  if (!hasActiveZangiaPlus(user)) {
    return null;
  }
  return <ZangiaPlusMemberBadge className={className} />;
}
